/* unplugin-vue-components disabled */import { render } from "./pulse-dashboard.vue?vue&type=template&id=e6e3f990&scoped=true"
import script from "./pulse-dashboard.vue?vue&type=script&lang=js"
export * from "./pulse-dashboard.vue?vue&type=script&lang=js"

import "./pulse-dashboard.vue?vue&type=style&index=0&id=e6e3f990&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6e3f990"],['__file',"src/pages/settings/admin/pulse-dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e6e3f990"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e6e3f990', __exports__)) {
    api.reload('e6e3f990', __exports__)
  }
  
  module.hot.accept("./pulse-dashboard.vue?vue&type=template&id=e6e3f990&scoped=true", () => {
    api.rerender('e6e3f990', render)
  })

}


export default __exports__